module.exports = __webpack_public_path__ + "static/img/excel.25efb1e4.svg";